import { h, Component } from 'preact';
import Store from 'store/store';
import 'store/bolt/homeEnt';
import 'store/bolt/homeEntLoader';
import 'store/bolt/previewPanel';
import NotificationBanner from 'components/bolt/sidePanel/notificationBanner';
import LoadIcon from 'components/bolt/sidePanel/loadIcon';
import Footer from 'components/bolt/footer/footer';
import Button from 'components/bolt/button/button';
import ShowtimesMessage from 'components/bolt/showtimes/showtimesMessage';
import Close from 'components/bolt/icons/close';
import Chevron from 'components/bolt/icons/chevron';
import Info from 'components/bolt/icons/info';
import MovieDetails from 'components/bolt/movieDetails/movieDetails';
import MovieDetailsClickableArea from 'components/bolt/movieDetails/movieDetailsClickableArea';
import DualMenu from 'components/bolt/dualMenu/dualMenu';
import MerchantPanel from 'components/bolt/homeEnt/merchantPanel';
import { accessNested, joinClasses, sortObjectByOrder } from 'utils/utils';
import parseQueryString from 'utils/parseQueryString';
import { isDualViewEnabled, linkOut } from 'utils/bolt';
import { geoFromIP } from 'utils/bolt/geo';
import { clamp } from 'utils/math';
import { getIsSinglePageIframed } from 'utils/bolt/client';
import { getMerchantLogo } from 'services/fafApi';
import { checkMerchantRegionalLogo } from 'utils/bolt/homeEnt';
import * as webp from 'utils/bolt/webp';
import s from 'components/bolt/homeEnt/homeEnt2.sss';


export default class HomeEnt extends Component {
	constructor(props) {
		super(props);
		this.scrollerClick = this.scrollerClick.bind(this);
		this.onMouseDown = this.onMouseDown.bind(this);
		this.onSelectFormat = this.onSelectFormat.bind(this);
		this.toggleFormatDropdown = this.toggleFormatDropdown.bind(this);
		this.closeMerchantSection = this.closeMerchantSection.bind(this);
		this.maybeCloseMerchantSection = this.maybeCloseMerchantSection.bind(this);
		this.onPriceBtnClick = this.onPriceBtnClick.bind(this);
		this.closeHomeEnt = this.closeHomeEnt.bind(this);
		this.getFallbackFormat = this.getFallbackFormat.bind(this);
		this.setActiveOverlay = this.setActiveOverlay.bind(this);
		this.stickAndScale = this.stickAndScale.bind(this);
		this.onScrollerScroll = this.onScrollerScroll.bind(this);
		this.checkTileSize = this.checkTileSize.bind(this);

		const baseCopy = accessNested(props, 'store.appData.copy.baseCopy', {});
		this.displayedFormats = {
			digital: baseCopy.$DIGITAL || 'Digital',
			bluRay: baseCopy.$BLURAY || 'Blu-ray',
			dvd: baseCopy.$DVD || 'DVD'
		};
		this.availabilityOrder = ['stream', 'rent', 'buy', 'preOrder', 'comingSoon'].reverse();
		this.state = {
			selectedFormat: '',
			availableFormats: [],
			formatDropdownOpen: false,
			availabilitiesToShow: [],
			userSelectedAvailabilities: [],
			merchantScreenOpen: false,
			selectedMerchantData: {},
			selectedRegionData: {},
			selectedLogo: '',
			selectedMerchant: '',
			regionToTrack: '',
			geoFromIP: {}
		};

		Store.on('STICK_AND_SCALE', this.stickAndScale);
	}

	getPageId() {
		let show = this.props.store.homeEnt?.show;
		let pageId = typeof show === 'string' && show ? show : this.lastPageId || 'boltHomeEnt';
		return this.lastPageId = pageId;
	}

	getPageData() {
		return this.props.homeEntPageData || accessNested(this.props, `store.appData.pages.${this.getPageId()}.data`) || {};
	}

	componentDidMount() {
		const pageId = this.getPageId();
		const homeEntData = this.props.store.homeEnt?.['data-' + pageId];
		if (!homeEntData || this.state.availableFormats.length === 0) {
			Store.emit('GET_HOMEENT_DATA', pageId, { pageData: this.getPageData() });
		}
		document.addEventListener('mousedown', this.onMouseDown);
		window.addEventListener('resize', this.checkTileSize);
		geoFromIP().then((geo) => {
			this.setState({ geoFromIP: geo });
		});

		this.preventClose = window.location.hash == '#no-clicks-out';
	}

	componentDidUpdate(prevProps, prevState) {
		const pageId = this.getPageId();
		const homeEntData = this.props.store.homeEnt?.['data-' + pageId];
		const prevHomeEntData = prevProps.store.homeEnt?.['data-' + pageId];

		let regions = this.getPageData().regions || '';
		regions = regions.toLowerCase().replace(/\s/g, '').split(',');
		const addProductsMultiRegion = this.getPageData().addProductsMultiRegion || {};

		const multiRegion = regions.length > 1 || Object.keys(addProductsMultiRegion).length > 0;

		const allRegions = [...new Set([...regions, ...Object.keys(addProductsMultiRegion)])].filter(a => a);

		if (!allRegions.length && !multiRegion) {
			allRegions.push('default');
		}

		if (homeEntData !== prevHomeEntData) {
			let formatOrder = ['digital', 'bluRay', 'dvd'].reverse();
			const customFormatOrder = accessNested(this.props, `store.appData.pages.${pageId}.data.formatOrder`);
			if (customFormatOrder) {
				formatOrder = customFormatOrder.split(',').map(f => f.trim()).reverse();
			}

			let availFormats = allRegions.reduce((acc, reg) => {
				let dataObj = multiRegion ? homeEntData[reg] : homeEntData;
				acc.push(Object.keys(dataObj || {}).filter((format) => Object.keys(dataObj[format]).length));
				return acc;
			}, []).flat().sort((a, b) => formatOrder.indexOf(b) - formatOrder.indexOf(a));

			availFormats = [...new Set(availFormats)];

			if (availFormats[0]) {
				Store.emit('HOME_ENT_FORMAT_SELECT', availFormats[0]);
			}

			if (this.state.geoFromIP.countryCode) {
				this.sortRegions(allRegions);
			}

			this.setState({
				availableFormats: availFormats,
				selectedFormat: availFormats[0],
				multiRegion
			});
		}

		if (this.state.geoFromIP !== prevState.geoFromIP) {
			this.sortRegions(allRegions);
		}

		const homeEntOpen = this.props.store.homeEnt?.show;
		const homeEntPrevClosed = !prevProps.store.homeEnt?.show;

		if (homeEntOpen && homeEntPrevClosed) {
			const hasFormats = this.state.availableFormats && this.state.availableFormats.length;
			if (hasFormats) {
				this.setState({
					selectedFormat: this.state.availableFormats[0]
				});
			}
		}


		if (!homeEntOpen && !homeEntPrevClosed) {
			if (this.state.formatDropdownOpen) {
				this.toggleFormatDropdown();
			}
			if (this.state.activeOverlay) {
				this.setState({ activeOverlay: null });
			}
		}

		const { selectedFormat } = this.state;
		const restrictedAvail = this.props?.store?.homeEnt?.restrictedAvailability;
		const prevRestrictedAvail = prevProps?.store?.homeEnt?.restrictedAvailability;

		if (selectedFormat && (selectedFormat !== prevState.selectedFormat || restrictedAvail !== prevRestrictedAvail)) {
			let foundAvailabilities = this.getAllAvailabilities(allRegions, multiRegion, homeEntData, selectedFormat, restrictedAvail);
			let userSelectedAvailabilities = foundAvailabilities;
			if (accessNested(this.props, `store.appData.pages.${pageId}.data.hideBtnShowingAllAvailabilities`)) {
				userSelectedAvailabilities = foundAvailabilities.slice(0, 1);
			}

			this.setState({
				availabilitiesToShow: foundAvailabilities,
				userSelectedAvailabilities
			});
		}

		this.preselectAvailsFromQuery();

		this.checkTileSize();
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.onMouseDown);
		window.removeEventListener('resize', this.checkTileSize);
		Store.off('STICK_AND_SCALE', this.stickAndScale);
	}

	checkTileSize() {
		let smallMerchantTiles = !!this.$merchantTile0 && this.$merchantTile0?.clientWidth < 121;
		if (smallMerchantTiles !== this.state.smallMerchantTiles) {
			this.setState({ smallMerchantTiles });
		}
	}

	onScrollerScroll(e) {
		const dualViewEnabled = isDualViewEnabled(this.props.pages);
		const maxScroll = (window.innerWidth / 16 * 9) - (dualViewEnabled ? 12 : 78);
		const translate = clamp(e.target.scrollTop, 0, maxScroll);

		if (e.target.scrollTop >= maxScroll && !this.state.headerIsSticky) {
			this.setState({ headerIsSticky: true });
		} else if (e.target.scrollTop < maxScroll && this.state.headerIsSticky) {
			this.setState({ headerIsSticky: false });
		}

		this.$dropdownContainer.style = `transform: translateY(-${translate}px)`;
	}

	getAllAvailabilities(allRegions, multiRegion, homeEntData = {}, selectedFormat, restrictedAvail) {
		if (restrictedAvail) {
			return [restrictedAvail];
		}
		const foundAvailabilities = allRegions.reduce((acc, reg) => {
			let dataObj = (multiRegion ? homeEntData[reg] : homeEntData) || {};
			const currentMerchants = Object.keys(dataObj[this.state.selectedFormat] || {});
			let availsForCurrentMerchants = currentMerchants.map(m => {
				const availsForSingleMerchant = Object.keys(dataObj[selectedFormat][m]).filter(avail => {
					const isComingSoon = avail === 'comingSoon';
					const comingSoonExpired = dataObj[selectedFormat][m].comingSoon && dataObj[selectedFormat][m].comingSoon.expired;
					if (isComingSoon && !comingSoonExpired) return true;
					if (dataObj[selectedFormat][m].comingSoon && !comingSoonExpired) return false;
					const potentialProducts = dataObj[selectedFormat][m][avail];
					if (!Array.isArray(potentialProducts)) return false;
					if (!potentialProducts.length) return false;
					return true;
				});
				// If there is no other availability for the merchant, show coming soon avail even if expired
				if (availsForSingleMerchant.length < 1 && dataObj[selectedFormat][m].comingSoon) {
					availsForSingleMerchant.push('comingSoon');
				}
				return availsForSingleMerchant;
			}).flat();
			acc.push(availsForCurrentMerchants);
			return acc;
		}, []).flat();

		return [...new Set(foundAvailabilities)].sort((a, b) => this.availabilityOrder.indexOf(b) - this.availabilityOrder.indexOf(a));
	}

	preselectAvailsFromQuery() {
		if (!window.location.search) {
			return;
		}
		const queries = parseQueryString();
		if (queries.availability) {
			const newAvail = queries.availability;
			if (!this.state.availabilitiesToShow?.includes(newAvail)) {
				return;
			}
			const currentAvail = this.state.userSelectedAvailabilities && this.state.userSelectedAvailabilities.join(',');
			if (newAvail !== currentAvail) {
				this.setState({
					userSelectedAvailabilities: [queries.availability]
				});
			}
		}
	}

	sortRegions(allRegions) {
		const regionCustomisations = this.getPageData().customiseRegion || {};
		const regionOrder = sortObjectByOrder(regionCustomisations, (val, key) => key ).reverse();
		const ipGeoCode = this.state.geoFromIP.countryCode;

		const sortedRegions = allRegions.sort((a, b) => {
			if (a === ipGeoCode) return -1;
			if (b === ipGeoCode) return 1;
			if (regionOrder && regionOrder.length) {
				return regionOrder.indexOf(b) - regionOrder.indexOf(a);
			}
			return 0;
		});

		this.setState({
			regions: sortedRegions
		});
	}

	getFallbackFormat(type) {
		const defaultFormat = type === 'tt' ? 'png' : 'jpg';
		const region = type === 'tt' ? 'tt' : 'bg';
		return accessNested(this.getPageData(), `${region}.alternativeImageFormat`, defaultFormat);
	}

	scrollerClick(e) {
		if (e.target === this.$scroller) {
			// Clicked / tapped outside the content
			this.closeHomeEnt();
		}
	}

	onMouseDown(e) {
		if (e.button !== 0 || this.preventClose || e.interactivity || !document.querySelector('.pageWrapper')?.contains(e.target)) {
			return;
		}
		let closestInteractiveElement = e.target.closest('input, button, a');
		if (!closestInteractiveElement) {
			this.closeHomeEnt();
		}
	}

	onPriceBtnClick(product, availability, merchant, region) {
		const { selectedMerchant, regionToTrack, selectedFormat } = this.state;
		const dataProvider = this.getDataProviderFromId(product.id);
		// let currency = this.state.selectedRegionData?.currency || this.props.store.appData.pages.boltHomeEnt.data.currency;
		Store.emit('HOME_ENT_CONVERSION', {
			merchant: merchant || selectedMerchant,
			selectedFormat,
			availability,
			product,
			dataProvider,
			region: region || regionToTrack
		});
	}

	onProviderAttributionClick(provider) {
		Store.emit('HOME_ENT_PROVIDER_ATTRIBUTION_CLICK', provider);
	}


	onSelectFormat(format) {
		this.setState({
			selectedFormat: format
		});
		this.state.formatDropdownOpen && this.toggleFormatDropdown();
		Store.emit('HOME_ENT_FORMAT_SELECT', format);
	}

	selectAvail(avail) {
		if (window.location.search) {
			const url = window.location.href.replace(window.location.search, '');
			history.replaceState(null, '', url);
		}
		if (avail === 'all') {
			this.setState({ userSelectedAvailabilities: this.state.availabilitiesToShow });
			return;
		}

		this.setState({
			userSelectedAvailabilities: [avail]
		});
	}

	toggleFormatDropdown() {
		let list = this.$formatOptions;
		let aboutToOpen = !this.state.formatDropdownOpen;
		this.setState({
			formatDropdownOpen: !this.state.formatDropdownOpen
		});

		if (list) {
			let height = '0';
			if (aboutToOpen) {
				let prevHeight = list.style.height;
				list.style.transition = 'none';
				list.style.padding = '0';
				list.style.height = 'auto';
				height = `${list.clientHeight}px`;
				list.style.padding = '';
				list.style.height = prevHeight;
				// Force reflow
				list.clientHeight;
				list.style.transition = '';
			}
			list.style.height = height;
		}
	}

	closeHomeEnt() {
		const isSinglePageIframed = getIsSinglePageIframed();
		if (isSinglePageIframed) return;

		const pages = accessNested(this.props, 'store.appData.pages', {});
		const noHome = !Object.keys(pages).includes('boltHome') && !Object.keys(pages).includes('boltPreviewPanel');
		if (noHome) return;

		Store.emit('HOMEENT_HIDE', true);
	}

	convertFafMerchantLogo(merchant) {
		const sharedImageRoot = accessNested(this.props, 'store.appData.urls.roots.sharedImages');
		return getMerchantLogo(merchant, sharedImageRoot);
	}

	getLogoSrc(merchant, logo, region) {
		if (!merchant) return;
		const pageId = this.getPageId();

		const pageData = this.props?.homeEntPageData || this.props?.pageData || this.props?.store?.appData?.pages?.[pageId]?.data || {};
		// merchantLogoOverrides will be legacy soon, let's give it lower priority than the logo override from overrideMerchantDetails
		const merchantLogoOverrides = pageData.overrideMerchantLogos || {};
		const merchantDetailsOverrides = pageData.overrideMerchantDetails || {};

		const manualLogo = merchantDetailsOverrides[merchant]?.logo || merchantLogoOverrides[merchant];
		if (manualLogo) return manualLogo;

		const logoShade = accessNested(this.props, 'store.appData.styling.logoShade', 'light');
		// logos from service-homeent use the prod logos, so let's always use them to prevent
		// inconsistencies on demo
		const sharedImageRoot = 'https://dx35vtwkllhj9.cloudfront.net/images';

		// manually added, probably
		if (!logo) {
			if (checkMerchantRegionalLogo(merchant, region)) {
				return `${sharedImageRoot}/boltHomeEntMerchants/${logoShade}/${region}/${merchant}_${logoShade}.png`;
			}
			return `${sharedImageRoot}/boltHomeEntMerchants/${logoShade}/${merchant}_${logoShade}.png`;
		}

		// generated and returned from service-homeent
		if (logo.match(/boltHomeEntMerchants/)) {
			return logo.replace(/<shade>/g, logoShade);
		}

		if (logo.match(/merchantlogo.s3-eu-west-1.amazonaws.com\/hub/)) {
			return this.convertFafMerchantLogo(merchant);
		}

		return logo;
	}

	getLogoAltText(merchant, merchantData) {
		const merchantDetailsOverrides = this.getPageData().overrideMerchantDetails || {};
		const merchantName = merchantDetailsOverrides[merchant]?.name || merchantData.merchantName || merchant;
		let logoAltText = merchantDetailsOverrides[merchant]?.logoAltText || accessNested(this.props, 'store.appData.copy.baseCopy.$MERCHANT_LOGO_ALT_TEXT', '');
		logoAltText = logoAltText.replace('<merchant>', merchantName);
		return logoAltText;
	}

	getMerchantColumns(deviceSize) {
		const ref = {
			mobile: 2,
			tablet: 3,
			smallDesktop: 3,
			desktop: 3,
			largeDesktop: 4
		};

		return ref[deviceSize] || 2;
	}

	getDataProviderFromId(productId) {
		if (!productId) return 'Manual';
		if (productId.startsWith('FAF')) return 'FindAnyFilm';
		if (productId.startsWith('JW')) return 'JustWatch';
	}

	openMerchant(data, logo, singleLinkOutData, regionData, merchant, currentRegion, i) {
		if (this.state.formatDropdownOpen) {
			this.toggleFormatDropdown();
		}

		const hasNoLinks = (singleLinkOutData && !singleLinkOutData.link) || (Object.keys(data).filter(a => a !== 'textOverlay' && a !== 'order').length <= 0);
		const hasOverlay = Object.keys(data).find(b => b === 'textOverlay');
		if (hasNoLinks && hasOverlay) {
			this.setActiveOverlay(null, i);
		}
		// if just a single link without any actual link, and no overlay either, clicking it should do nothing
		if (hasNoLinks) return;

		const appRegion = accessNested(this.props, 'store.appData.meta.region.slug');
		let regionToTrack = currentRegion;
		if (regionToTrack === 'default') regionToTrack = appRegion;
		Store.emit('HOME_ENT_MERCHANT_SELECT', { region: regionToTrack, merchant });

		if (singleLinkOutData && (!data.comingSoon || (data.comingSoon && data.comingSoon.expired))) {
			this.onPriceBtnClick({
				id: singleLinkOutData.productId,
				price: singleLinkOutData.price,
				edition: singleLinkOutData.edition
			}, singleLinkOutData.availForProduct, merchant, regionToTrack);
			linkOut(singleLinkOutData.link);
			return;
		}

		// if it is only an expired comingSoon with no other avails, clicking should do nothing
		if (data.comingSoon && data.comingSoon.expired && (Object.keys(data).length === 1 || (Object.keys(data).length === 2 && !!data.order))) {
			return;
		}

		Store.emit('OPEN_MERCHANT_SECTION');
		this.setState({
			merchantScreenOpen: true,
			selectedMerchantData: data,
			selectedMerchant: merchant,
			regionToTrack,
			selectedLogo: logo,
			selectedRegionData: regionData
		});
	}

	closeMerchantSection() {
		Store.emit('CLOSE_MERCHANT_SECTION');
		this.setState({
			merchantScreenOpen: false
		});
	}

	setActiveOverlay(e, i) {
		if (e) {
			e.stopPropagation();
		}
		const { activeOverlay } = this.state;
		this.setState({ activeOverlay: i === activeOverlay ? null : i });
	}

	maybeCloseMerchantSection(e) {
		if (e.target === this.merchantPanel?.$merchantSectionContainer || e.target === this.merchantPanel?.$merchantSectionScroller) {
			this.closeMerchantSection();
		}
	}

	getSingleLinkForMerchant(merchantData, userSelectedAvailabilities) {
		let link;
		let productId;
		let edition;
		let price;
		let availForProduct;
		let productCount = 0;

		userSelectedAvailabilities.forEach(a => {
			if (merchantData[a] && merchantData[a].length) {
				productCount += merchantData[a].length;
				link = merchantData[a][0].link;
				productId = merchantData[a][0].id;
				edition = merchantData[a][0].edition;
				price = merchantData[a][0].price;
				availForProduct = a;
			}
		});

		if (productCount !== 1) return false;
		return { link, productId, edition, price, availForProduct };
	}

	stickAndScale(percentage) {
		const dualViewEnabled = isDualViewEnabled(this.props.pages);
		const { onesheetDisabled } = this.props;
		const { isDesktopSize } = this.props.store.client;

		if (isDesktopSize) {
			const maxLeft = onesheetDisabled ? 0 : (window.innerHeight * 609 / 900);
			const left = maxLeft * percentage;
			this.$container.style.left = left + 'px';
			this.$container.style.top = '0px';
		} else {
			const maxTop = 72;
			const top = (dualViewEnabled ? -6 : 16) + (maxTop * percentage);
			this.$container.style.top = top + 'px';
			this.$container.style.left = '0px';
			this.$container.style.borderRadius = `${20 - (20 * percentage)}px`;
			if (dualViewEnabled) {
				this.$container.style.overflow = 'hidden';
			} else {
				this.$content.style.borderRadius = `0 0 ${20 - (20 * percentage)}px ${20 - (20 * percentage)}px`;
				this.$content.style.overflow = 'hidden';
			}

			const headerHeight = this.props.store.appData?.header?.curzonHeader ? 80 : 64;
			this.$content.style.minHeight = `calc(100% - ${(window.innerWidth / 16 * 9) * percentage}px + ${headerHeight * percentage}px)`;

			let dropDownTop = ((dualViewEnabled ? 86 : -16) + (percentage * ((window.innerWidth / 16 * 9) - 80)));
			this.$dropdownContainer.style.top = dropDownTop + 'px';
		}
	}

	renderMerchants(data, format, columns, isLoading, currentRegion) {
		if (isLoading) {
			return (
				<div class={s.merchants}>
					{Array(columns === 2 ? 6 : 12).fill('').map((m, i) => <div key={i} class={s.dummyMerchant} />)}
				</div>
			);
		}

		const { multiRegion, regions, smallMerchantTiles, activeOverlay } = this.state;
		const isFirstRegion = regions && currentRegion === regions[0];
		const regionCustomisations = this.getPageData().customiseRegion || {};
		const regionData = regionCustomisations[currentRegion] || {};
		const fontStyling = accessNested(this.props, 'store.appData.styling.fontVariables', {});
		const logoShade = accessNested(this.props, 'store.appData.styling.logoShade', 'light');

		if (!data || !format || !data[format]) return;

		const { userSelectedAvailabilities } = this.state;
		let merchants = Object.keys(data[format]).filter(m => {
			if (m === 'undefined') return false;

			// don't render the merchant if it has no products to show within the selected availabilities
			let hasProduct = false;

			userSelectedAvailabilities.forEach(a => {
				if (data[format][m][a] && data[format][m][a].length) hasProduct = true;
			});

			if (userSelectedAvailabilities.includes('comingSoon') && data[format][m].comingSoon) {
				// if the comingSoon has expired and there are other avails for the merchant,
				// we don't want to show it under comingSoon
				if (!(data[format][m].comingSoon.expired && (Object.keys(data[format][m]).length > 1))) {
					hasProduct = true;
				}
				// we can still show it under comingSoon if it only has one other property, which is 'order'
				if (data[format][m].comingSoon.expired && (Object.keys(data[format][m]).length === 2) && !!data[format][m].order) {
					hasProduct = true;
				}
			}

			// If merchant has an active 'coming soon', it should not appear in any other availability
			if (data[format][m].comingSoon && !data[format][m].comingSoon.expired && !userSelectedAvailabilities.includes('comingSoon')) {
				hasProduct = false;
			}

			return hasProduct;
		}).sort((a, b) => {
			if (data[format][a].order && data[format][b].order) {
				return (data[format][a].order - data[format][b].order);
			}
			if (data[format][a].order) {
				return -1;
			}
			if (data[format][b].order) {
				return 1;
			}
			return a.localeCompare(b);
		});

		if (!merchants.length) return;

		const dangling = merchants.length % columns;
		const numDummiesNeeded = !dangling ? 0 : columns - dangling;
		const dummyArray = new Array(numDummiesNeeded).fill('dummyElement');

		if (dummyArray.length) {
			merchants = merchants.concat(dummyArray);
		}

		return (
			<div class={joinClasses(s.merchants, !isFirstRegion && s.extraRegion, smallMerchantTiles && s.smallMerchantTiles)}>
				{multiRegion && (
					<div class={s.regionHeader}>
						<span class={joinClasses(s.regionTitle, fontStyling.homeEntRegionHeader)}>{regionData.title}</span>
						<div class={s.titleLine} />
					</div>
				)}
				{merchants.map((m, i) => {
					if (m === 'dummyElement') return <div key={i} class={s.dummyMerchant} />;

					const logo = this.getLogoSrc(m, data[format][m].logo, currentRegion);
					const fallbackFormat = this.getFallbackFormat();

					const singleLinkOutData = this.getSingleLinkForMerchant(data[format][m], userSelectedAvailabilities);
					const isSingleLinkButWithNoLink = singleLinkOutData && !singleLinkOutData.link;
					const isLoneExpiredComingSoon = data[format][m].comingSoon && data[format][m].comingSoon.expired && (Object.keys(data[format][m]).length === 1 || Object.keys(data[format][m]).length === 2 && !!data[format][m].order);

					let textOverlay = data[format][m].textOverlay;
					if (textOverlay && typeof textOverlay !== 'string') {
						textOverlay = textOverlay.join('');
					}
					const isUnclickableMerchant = (isSingleLinkButWithNoLink || isLoneExpiredComingSoon) && !textOverlay;

					return (
						<div
							class={joinClasses(s.merchant, isUnclickableMerchant && s.unclickable)}
							key={`${m}-${currentRegion}`}
							onClick={e => this.openMerchant(data[format][m], logo, singleLinkOutData, regionData, m, currentRegion, i, e)}
							ref={e => this[`$merchantTile${i}`] = e}
						>
							{textOverlay && (
								<div class={joinClasses(s.overlayWrapper, (activeOverlay === i) && s.active, s[logoShade])}>
									<button class={s.overlayButton} onClick={e => this.setActiveOverlay(e, i)}>
										{activeOverlay === i ? <Close /> : <Info />}
									</button>
									<div class={joinClasses(s.overlayContainer, 'smallB')}>
										{textOverlay}
									</div>
								</div>
							)}
							<webp.Picture
								alt={this.getLogoAltText(m, data[format][m])}
								src={logo}
								fallbackFormat={fallbackFormat}
							/>
						</div>
					);
				})}
			</div>
		);
	}

	renderFormatOptions(formats, dualViewEnabled) {
		const { selectedFormat, formatDropdownOpen } = this.state;
		if (formats.length < 1) return;
		// add any custom formats to displayedFormats
		const baseCopy = accessNested(this.props, 'store.appData.copy.baseCopy', {});
		formats.forEach((format) => {
			if (this.displayedFormats[format]) return;
			const formatCopyName = baseCopy[`$${format.toUpperCase().replace(' ', '_')}`];
			this.displayedFormats[format] = formatCopyName || format;
		});
		return (
			<div
				class={joinClasses(s.formatOptions, !formatDropdownOpen && s.formatDropdownHidden, dualViewEnabled && s.dualMenu)}
				ref={e => this.$formatOptions = e}
			>
				{formats.map(f => (
					<div key={f} onClick={() => this.onSelectFormat(f)} class={joinClasses(s.option, selectedFormat === f && s.hideOption)}>
						{this.displayedFormats[f]}
					</div>
				))}
			</div>
		);
	}

	renderMerchantSection() {
		const { selectedMerchant, selectedMerchantData, selectedLogo, merchantScreenOpen, userSelectedAvailabilities, selectedRegionData } = this.state;

		const fallbackFormat = this.getFallbackFormat('tt');
		const logoAltText = this.getLogoAltText(selectedMerchant, selectedMerchantData);

		return (
			<MerchantPanel
				ref={ref => this.merchantPanel = ref}
				appData={this.props.store?.appData}
				pageId={this.getPageId()}
				userSelectedAvailabilities={userSelectedAvailabilities}
				availabilityOrder={this.availabilityOrder}
				merchantScreenOpen={merchantScreenOpen}
				maybeCloseMerchantSection={this.maybeCloseMerchantSection}
				closeMerchantSection={this.closeMerchantSection}
				onPriceBtnClick={this.onPriceBtnClick}
				selectedLogo={selectedLogo}
				selectedMerchantData={selectedMerchantData}
				selectedMerchant={selectedMerchant}
				fallbackFormat={fallbackFormat}
				selectedRegionData={selectedRegionData}
				logoAltText={logoAltText}
			/>
		);
	}

	renderProviderAttributes(isEmpty) {
		const hasFAFData = accessNested(this.props, 'store.homeEnt.hasFAFData', false);
		const hasJustWatchData = accessNested(this.props, 'store.homeEnt.hasJustWatchData', false);
		if (!hasFAFData && !hasJustWatchData) {
			return;
		}
		const dual = hasFAFData && hasJustWatchData;
		const copy = accessNested(this.props, 'store.appData.copy.baseCopy', {});
		const accessibilityCopy = accessNested(this.props, 'store.appData.copy.accessibilityCopy', {});
		const logoShade = accessNested(this.props, 'store.appData.styling.logoShade', 'light');
		const sharedImageRoot = accessNested(this.props, 'store.appData.urls.roots.sharedImages', '');
		const fontVariables = accessNested(this.props, 'store.appData.styling.fontVariables', '');
		const fafLogo = `${sharedImageRoot}/boltHomeEntMerchants/${logoShade}/providers/findanyfilm_${logoShade}.png`;
		const justWatchLogo = `${sharedImageRoot}/boltHomeEntMerchants/${logoShade}/providers/justwatch_${logoShade}.png`;
		const logoAlt = accessibilityCopy.$PROVIDER_LOGO_ALT || '<provider> logo';
		const fafLinkDisabled = accessNested(this.getPageData(), 'disableProviderAttributionLink.faf', false);
		const jwLinkDisabled = accessNested(this.getPageData(), 'disableProviderAttributionLink.justWatch', false);
		const fafLink = 'https://www.findanyfilm.com';
		const jwLink = 'https://www.justwatch.com';
		const fallbackFormat = this.getFallbackFormat('tt');

		let jwElement = <webp.Picture class={s.providerLogo} src={justWatchLogo} alt={logoAlt.replace('<provider>', 'JustWatch')} fallbackFormat={fallbackFormat} />;
		let fafElement = <webp.Picture class={s.providerLogo} src={fafLogo} alt={logoAlt.replace('<provider>', 'FindAnyFilm')} fallbackFormat={fallbackFormat} />;

		if (!jwLinkDisabled) {
			jwElement = (
				<a href={jwLink} target="_blank" onClick={() => this.onProviderAttributionClick('JustWatch')}>
					{jwElement}
				</a>
			);
		}

		if (!fafLinkDisabled) {
			fafElement = (
				<a href={fafLink} target="_blank" onClick={() => this.onProviderAttributionClick('FindAnyFilm')}>
					{fafElement}
				</a>
			);
		}

		return (
			<div class={joinClasses(s.providerAttributes, isEmpty && s.providerEmpty)} style={fontVariables.small}>
				<div class={s.poweredBy}>{copy.$POWERED_BY || 'Powered By'}</div>
				{hasJustWatchData && jwElement}
				{dual && <div class={s.divider} />}
				{hasFAFData && fafElement}
			</div>
		);
	}

	render(props) {
		const pageId = this.getPageId();
		const appData = props.store?.appData || {};
		const homeEntStore = props.store.homeEnt;
		const homeEntData = homeEntStore?.['data-' + pageId] || homeEntStore?.data;
		const pageData = this.getPageData();
		const { selectedFormat, availableFormats, availabilitiesToShow, userSelectedAvailabilities, formatDropdownOpen, regions, multiRegion, headerIsSticky } = this.state;
		const isLoading = homeEntStore?.['loading-' + pageId] !== false; // undefined should be considered loading
		const hasError = !isLoading && homeEntStore.error;
		const isEmpty = !hasError && !isLoading && availableFormats && availableFormats.length < 1;
		const hasMultipleAvailFormats = availableFormats.length > 1;

		const client = props.store.client || {};
		const copy = appData.copy || {};
		const scrollElem = client.isDesktopSize ? this.$merchantContainer : this.$scroller;
		const footerBgColorFallback = appData.styling?.variables?.tertiaryColor;
		const fontStyling = appData.styling?.fontVariables || {};

		const cookies = accessNested(props, 'store.cookies') || {};
		const sonyHeaderEnabled = accessNested(appData, 'options.sonyFeatures.sonyHeader', false);
		const externalBannerOpen = accessNested(props, 'store.externalCookieBanner.bannerOpen');
		const cookieMode = externalBannerOpen || (accessNested(cookies, 'pushDown', false) && accessNested(cookies, 'cookieBannerOpen', false));
		let style = {};
		let cookieHeight = 0;
		let containerStyle = {};
		if (cookieMode) {
			cookieHeight = externalBannerOpen ? accessNested(props, 'store.externalCookieBanner.height') : accessNested(cookies, 'height');
			style.top = cookieHeight + 'px';
			style.height = 'calc(var(--windowHeight) - ' + cookieHeight + 'px)';

			if (client.isDesktopSize) {
				containerStyle.left = ((window.innerHeight - cookieHeight - (sonyHeaderEnabled ? 35 : 0)) / 900 * 609) + 'px';
			}
		}

		containerStyle.pointerEvents = props.contentDisabled ? 'none' : 'all';
		const merchantColumns = this.getMerchantColumns(client.deviceSize);

		const dualViewEnabled = isDualViewEnabled(this.props.pages);
		const errorLoadOrEmpty = hasError || isLoading || isEmpty;

		return (
			<div class={joinClasses(s.wrapper, dualViewEnabled && s.dualMenu, props.isWidget && s.widget, !hasMultipleAvailFormats && s.singleFormat)}>
				<MovieDetails
					type="homeEnt"
					tt={pageData.tt}
					bg={pageData.bg}
					buttons={pageData.buttons}
					visible={props.isWidget || homeEntStore.show}
					copy={copy}
					appData={appData}
					cookieHeight={cookieHeight}
					cookieBannerOpen={cookieMode}
					dualViewEnabled={dualViewEnabled}
					key="homeEntMovieDetails"
					isWidget={props.isWidget}
					class={joinClasses(s.movieDetails, (!client.isDesktopSize && this.state.headerIsSticky) && s.blur)}
				/>
				<div
					class={joinClasses({
						s,
						container: true,
						animate: homeEntStore.animate,
						displayed: homeEntStore.show,
						loading: homeEntStore.loading,
						sonyHeader: sonyHeaderEnabled
					})}
					style={containerStyle}
					ref={ref => this.$container = ref}
				>
					<div ref={ref => this.$dropdownContainer = ref} class={s.dropDownContainer}>
						<div
							class={joinClasses(s.dropDown, !hasMultipleAvailFormats && s.singleFormatDropDown)}
							onClick={hasMultipleAvailFormats && this.toggleFormatDropdown}
						>
							<span>{this.displayedFormats[selectedFormat] || ''}</span>
						</div>
						{hasMultipleAvailFormats && <Chevron class={joinClasses(s.chevron, formatDropdownOpen && s.openChevron)} ariaLabel="Format Dropdown" />}
						{this.renderFormatOptions(availableFormats, dualViewEnabled)}
					</div>
					<div
						id="homeEntScroller"
						class={s.scroller}
						data-section="scroller"
						ref={e => this.$scroller = e}
						onClick={this.scrollerClick}
						onScroll={this.onScrollerScroll}
					>
						<MovieDetailsClickableArea
							fallbackClickHandler={props.isWidget ? this.props.exitWidget : this.closeHomeEnt}
							isWidget={props.isWidget}
							dualViewEnabled={dualViewEnabled}
							homeEnt
						/>
						<div class={joinClasses({ s, content: true, headerFaded: errorLoadOrEmpty })} ref={ref => this.$content = ref}>
							{dualViewEnabled && <DualMenu isWidget={props.isWidget && 'homeEnt'} widgetData={props.widgetData} pages={this.props.pages} />}
							<div class={joinClasses(s.collapseHeader, dualViewEnabled && s.dualMenu, headerIsSticky && s.showShadow)} />
							<div class={s.sticky}>
								<div class={s.stickyAvailScroller}>
									<div class={s.shadow} />
									{errorLoadOrEmpty && <div class={joinClasses(s.availBtn, s.loadingAvail)} />}
									{!isLoading && availabilitiesToShow.length > 1 && !pageData.hideBtnShowingAllAvailabilities && (
										<Button
											type="tag"
											class={s.availBtn}
											activeClass={s.activeAvail}
											active={availabilitiesToShow.length === userSelectedAvailabilities.length}
											trigger={() => this.selectAvail('all')}
										>
											<span class={fontStyling.homeEntAvailFilterBtn}>{copy.baseCopy.$AVAIL_ALL || 'All'}</span>
										</Button>
									)}
									{!isLoading && availabilitiesToShow.map((avail) => {
										if (avail === 'textOverlay') return;
										return (
											<Button
												type="tag"
												class={s.availBtn}
												activeClass={s.activeAvail}
												active={(availabilitiesToShow.length !== userSelectedAvailabilities.length) && userSelectedAvailabilities.includes(avail) || availabilitiesToShow.length === 1}
												trigger={() => this.selectAvail(avail)}
											>
												<span class={fontStyling.homeEntAvailFilterBtn}>{copy.baseCopy[`$AVAIL_${avail.toUpperCase()}`] || avail}</span>
											</Button>
										);
									})}
									<div className={s.filler} />
								</div>
							</div>
							<div
								id="homeEntMerchantContainer"
								class={joinClasses(s.merchantContainer, dualViewEnabled && s.dualView)}
								ref={e => this.$merchantContainer = e}
								onScroll={e => this.props.handleWidgetScroll && this.props.handleWidgetScroll(e)}
							>
								{!hasError && <NotificationBanner isHomeEnt region={props.store?.client?.geo?.countryCode} movies={props.store?.showtimes?.movies} />}
								{hasError && (
									<ShowtimesMessage
										class={s.errorContainer}
										deviceSize={client.deviceSize}
										message={copy.baseCopy.$ERROR_HOMEENT}
										cta={copy.baseCopy.$ERROR_HOMEENT_CTA}
										buttonCopy={copy.baseCopy.$REFRESH || 'Refresh'}
										buttonTrigger={() => location.reload()}
										key="homeent-error"
									/>
								)}
								{isEmpty && (
									<ShowtimesMessage
										class={s.errorContainer}
										deviceSize={client.deviceSize}
										message={copy.baseCopy.$NO_HOME_ENT}
										icon="coming-soon"
										key="homeent-empty"
									/>
								)}
								{isLoading && (
									<div class={s.loadingTxtContainer}>
										<span class={joinClasses(s.loadingTxt, fontStyling.homeEntLoading)}>{copy.baseCopy.$HOME_ENT_LOADING || 'Loading providers'}</span>
										<LoadIcon class={s.loadIcon} />
									</div>
								)}
								<div class={joinClasses(s.merchantContent, isEmpty && s.emptyMerchants)}>
									{(regions || ['default']).map((r) => this.renderMerchants(multiRegion ? homeEntData[r] : homeEntData, selectedFormat, merchantColumns, isLoading, r))}
									{this.renderProviderAttributes(isEmpty)}
								</div>
								{!props.isWidget && (
									<Footer
										data={appData.footer}
										parent="showtimes"
										scrollElem={scrollElem}
										fallBackColor={footerBgColorFallback}
										key="footer"
										store={this.props.store}
										isHomeEntFooter
									/>
								)}
							</div>
						</div>
					</div>
				</div>
				{this.renderMerchantSection()}
			</div>
		);
	}

}
